<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-rule"></div>
                    <p v-for="(item,index) in rule_text" :key="index"><em class="index">{{ index + 1 }}</em>{{ item }}</p>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'evt_rule_modal',
    data : function () {
        return {
            visible : false,
            rule_text : ['被邀请的回归玩家，需要点击你的专属链接且登录过游戏，即为邀请成功。如果出现回归好友显示未登录的情况，请好友重新登录网页更新状态。',
            '一个招募者可邀请5名好友来完成任务。一个回归玩家同时只能被一个招募者招募。',
            '回归玩家条件：被招募时的等级需要≥11级，最后一次登录在2021年12月10日之前，最近30天内没有登录过。',
            '幸运抽奖中，每消耗一张抽奖券即可进行一次抽奖，实物奖励将在活动结束后30个工作日内发出。',
            '活动时间：1月13日 10点 ~2月11日 23点59分。奖励领取时间截止到2月14日23:59。',
            ],            
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

    @media screen and (min-device-width: 1025px){
    .rule-modal{
        width: 469px;
        height: 467px;
        background-image: url(../../images/bg-modal-rule.png);
    }

    .rule-modal .u-btn.close{
        top: 12px;
    }    

    .t-rule{
        width: 156px;
        height: 35px;
        margin: 0 auto 25px;
        background-image: url(../../images/title-rule.png);
    }

    .rule-modal .dialog-wrapper{
        padding: 40px 40px 0;
    }    

    .rule-modal p{
        position: relative;
        color: #63544b;
        line-height: 1.8;
        padding-left: 40px;
        margin-bottom: 12px;
    }

    .rule-modal p .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 27px;
        height: 27px;
        line-height: 27px;
        background-image: url(../../images/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }
    }

    @media screen and (max-device-width: 1024px){
    .rule-modal{
        width: 609px;
        height: 712px;
        background-image: url(../../images/m/bg-modal-rule.png);
    }


    .t-rule{
        width: 191px;
        height: 42px;
        margin: 0 auto 15px;
        background-image: url(../../images/m/title-rule.png);
    }

    .rule-modal .dialog-wrapper{
        padding: 40px 40px 0;
    }    

    .rule-modal p{
        position: relative;
        color: #63544b;
        line-height: 1.6;
        padding-left: 50px;
        margin-bottom: 12px;
    }

    .rule-modal p .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 43px;
        height: 43px;
        line-height: 43px;
        background-image: url(../../images/m/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }        
    }

</style>


// WEBPACK FOOTER //
// src/components/EvtRule/EvtRule.vue